import { render, staticRenderFns } from "./dictManage.vue?vue&type=template&id=09f77c7f&"
import script from "./dictManage.vue?vue&type=script&lang=js&"
export * from "./dictManage.vue?vue&type=script&lang=js&"
import style0 from "./dictManage.vue?vue&type=style&index=0&id=09f77c7f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports